import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "angle-left",
  "use": "angle-left-usage",
  "viewBox": "0 0 7 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 12\" id=\"angle-left\">\n    <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M5.453 0L0 5.833l5.453 5.834L7 10.012 3.094 5.833 7 1.655z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol